
















import { gsap } from "gsap";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import TextLink from "@/common/components/atoms/TextLink.vue";
import ServiceLogo from "@/common/components/atoms/ServiceLogo.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import IconEyeInvisible from "@/common/components/icons/IconEyeInvisible.vue";
import IconEyeVisible from "@/common/components/icons/IconEyeVisible.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";
import { getContractInfos } from "@/general/store/api";
import { component } from "vue/types/umd";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

@Component({
  components: {
    TheFooter,
    InputText,
    ButtonMain,
    TextLink,
    ServiceLogo,
    IconBase,
    IconArrowBottom,
    IconEyeInvisible,
    IconEyeVisible,
    ValidationErrorText,
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapState({
      colorCode: () => commons.OrgPageSpecific?.page_color
    })
  }
})
export default class NotContractedIc extends Vue {
  loginAuthentication: any = false;

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    this.loginAuthentication = true;
    LocalStorage.setItem("NotContractedIc", "1");
  }
}
